<template>
  <div class="page about-page">
    <section class="about-intro section-wrap">
      <div class="about-photo-wrap reveal-up">
        <div class="about-photo-card">
          <img src="../assets/images/mypic2023.jpg" alt="Gagan Ajjikuttira smiling outdoors" />
          <p>One of the good hair days.</p>
        </div>
        <span class="photo-stamp">BORN IN INDIA<br />BUILDING IN CALIFORNIA</span>
      </div>

      <div class="about-copy reveal-up reveal-delay">
        <p class="section-kicker">THE HUMAN BEHIND THE TERMINAL</p>
        <h1>Curious kid.<br />Daydreamer.<br /><em>Still taking things apart.</em></h1>
        <p class="about-lede">
          I grew up in southern India building makeshift lifts from scrap motors
          and dismantling RC cars just to see whether I could put them back together.
        </p>
        <p>
          That instinct never left. Today I build AI and infrastructure products,
          but the question is still the same: <strong>what&rsquo;s really happening
          underneath—and can it work better?</strong>
        </p>
        <div class="about-facts">
          <div><small>CURRENTLY</small><strong>Software Engineer at Meta</strong></div>
          <div><small>HOME BASE</small><strong>San Francisco Bay Area</strong></div>
          <div><small>ALWAYS UP FOR</small><strong>F1, beaches, pizza, the universe</strong></div>
          <div><small>LANGUAGES</small><strong>English, Hindi + one more</strong></div>
        </div>
      </div>
    </section>

    <section class="timeline-section section-wrap">
      <div class="section-heading split-heading">
        <div><p class="section-kicker">THE LONG VERSION</p><h2>Where I&rsquo;ve been.</h2></div>
        <p class="section-aside">A path through ranking systems, AI products, observability, research, and a lot of shipping.</p>
      </div>

      <div class="timeline">
        <article v-for="item in timeline" :key="`${item.company}-${item.period}`">
          <div class="timeline-period">{{ item.period }}</div>
          <div class="timeline-dot"></div>
          <div class="timeline-copy">
            <p>{{ item.company }}</p>
            <h3>{{ item.role }}</h3>
            <span>{{ item.note }}</span>
          </div>
        </article>
      </div>
    </section>

    <section class="education-section section-wrap">
      <div class="education-copy">
        <p class="section-kicker">FORMAL TRAINING</p>
        <h2>Computer science,<br />from foundations to frontiers.</h2>
      </div>
      <div class="education-cards">
        <article>
          <span>01</span><small>STONY BROOK UNIVERSITY · 2021—22</small>
          <h3>MS, Computer Science</h3><p>3.83 / 4.0 · Big Data, Networks, Computer Vision, HCI</p>
        </article>
        <article>
          <span>02</span><small>IIIT ALLAHABAD · 2016—20</small>
          <h3>BTech, Information Technology</h3><p>9.01 / 10 · Algorithms, AI, Systems, Data Mining</p>
        </article>
      </div>
    </section>

    <section class="about-outro section-wrap">
      <p class="section-kicker">THINGS THAT KEEP ME HUMAN</p>
      <div class="interest-cloud" aria-label="Personal interests">
        <span>Formula 1</span><span>Cars</span><span>The universe</span><span>New tech</span><span>Psychology</span><span>Beaches</span><span>Modern Family</span><span>Pizza</span>
      </div>
      <div class="local-time">
        <span class="status-dot"></span>
        <p>It&rsquo;s currently <strong>{{ time }}</strong> where I live.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: "",
      timer: null,
      timeline: [
        { period: "2025—NOW", company: "META", role: "Software Engineer — Ads ML Infra", note: "Autonomous agents for Ads ranking model iteration." },
        { period: "2024—25", company: "EIGHTFOLD", role: "Software Engineer — Data & AI Integrations", note: "Platform integrations, AI Recruiter, and Voice Screening agents." },
        { period: "2022—24", company: "SUMO LOGIC", role: "Software Engineer II — Observability", note: "Dashboard systems and large-scale product migration." },
        { period: "2020—21", company: "BLINKIT (FORMERLY GROFERS)", role: "Software Engineer — Ads Platform", note: "Built advertising services spanning auctioning and targeting." },
      ],
    };
  },
  mounted() {
    this.updateTime();
    this.timer = window.setInterval(this.updateTime, 60000);
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  methods: {
    updateTime() {
      this.time = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Los_Angeles",
        hour: "numeric",
        minute: "2-digit",
      }).format(new Date());
    },
  },
};
</script>
